import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-mat-confirm-dialog',
    styleUrls: ['./mat-confirm-dialog.component.scss'],
    templateUrl: './mat-confirm-dialog.component.html',
    standalone: false
})
export class MatConfirmDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<MatConfirmDialogComponent>
    ) {}

    ngOnInit() {}

    closeDialog() {
        this.dialogRef.close(false);
    }

}
